import { type FC } from 'react';

import { type AdditionalContentField } from '@core/blocks/edu-flow-2/components/AdditionalContentFields/types';

import styles from './StatCta.module.css';

const StatCta: FC<{ field?: AdditionalContentField }> = ({ field }) => (
  <div className={styles.statCta}>
    {field ? (
      <>
        {field.prefix && <p>{field.prefix}</p>}
        <h2 className={styles.statNumber}>{field.heading}</h2>
        {field.content &&
          field.content
            .split('.')
            .filter(Boolean)
            .map((text, i) => <p key={i}>{text.trim()}.</p>)}
      </>
    ) : (
      <>
        <p>We have over</p>
        <h2 className={styles.statNumber}>300</h2>
        <p>potential matches for you.</p>
        <p>Let&apos;s personalize that list some more.</p>
      </>
    )}
  </div>
);
export default StatCta;
